import { useState, useEffect } from "react";
import * as styles from "./HighlightsSlider.module.css";
import highlightData from "../../assets/data/highlightData.json";
import { motion, AnimatePresence } from "framer-motion";

// Define the data structure type
interface HighlightItem {
  title: string;
  value: string;
  unit: string;
}

const getRandomValue = (title: string, baseValue: string) => {
  switch (title) {
    case "Stocks Analysed":
      return `${Math.floor(Math.random() * (1200 - 950) + 950)}`;
    case "Quant Parameters":
      return `${Math.floor(Math.random() * (3500 - 3000) + 3000)}`;
    case "Throughput":
      return `${(Math.random() * (3.5 - 2.8) + 2.8).toFixed(2)}`;
    default:
      return baseValue;
  }
};

const HighlightsSlider = () => {
  const [dynamicData, setDynamicData] = useState<HighlightItem[]>(highlightData);

  useEffect(() => {
    const updateMetric = (title: string) => {
      setDynamicData((prevData) =>
        prevData.map((item) =>
          item.title === title ? { ...item, value: getRandomValue(item.title, item.value) } : item
        )
      );
    };

    const stocksInterval = setInterval(() => updateMetric("Stocks Analysed"), Math.random() * 2000 + 2000);
    const quantInterval = setInterval(() => updateMetric("Quant Parameters"), Math.random() * 6000 + 2000);
    const throughputInterval = setInterval(() => updateMetric("Throughput"), Math.random() * 5000 + 2000);

    return () => {
      clearInterval(stocksInterval);
      clearInterval(quantInterval);
      clearInterval(throughputInterval);
    };
  }, []);

  return (
    <div className={styles.marqueeContainer}>
      <div className={styles.marqueeContent}>
        {[...dynamicData, ...dynamicData].map((item, i) => (
          <div key={i} className={styles.marqueeItem}>
            <p className={styles.title}>{item.title}</p>
            <h2 className={styles.value}>
              {item.value.split("").map((digit, index) => {
                const isEven = index % 2 === 0;
                const initialY = isEven ? "100%" : "-100%";
                const exitY = isEven ? "-100%" : "100%";

                return (
                  <div key={index} className={styles.digitWrapper}>
                    <AnimatePresence mode="sync">
                      <motion.span
                        key={digit + index}
                        className={styles.digit}
                        initial={{ y: initialY, opacity: 0 }}
                        animate={{ y: "0%", opacity: 1 }}
                        exit={{ y: exitY, opacity: 0 }}
                        transition={{ duration: 0.2, ease: "linear" }}
                      >
                        {digit}
                      </motion.span>
                    </AnimatePresence>
                  </div>
                );
              })}
              <span className={styles.unit}> {item.unit}</span>
            </h2>
          </div>
        ))}
      </div>
      <div className={styles.marqueeOverlay}></div>
    </div>
  );
};

export default HighlightsSlider;
